<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div *ngIf="outOfScope" class="qb-content-card m-4 p-4">
    <h5 class="text-red-600">Not authorized</h5>
    <p>This Account User is not in your supervised scope in the Proximity Organization Tree.
       Contact your Principal Account Administrator to make changes to this user.</p>
  </div>
  <ng-container *ngIf="!outOfScope">
  <h5 class="card-header">
    <div class="flex flex-row">
      <span>{{formTitle}}</span>
      <span *ngIf="isAccountAdmin()" class="ml-4">(Account Administrator)</span>
      <span *ngIf="!isBeingAdded" class="qb-status-message">{{statusMessage()}}</span>
    </div>
  </h5>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="splitterPanelSizes()">
    <ng-template pTemplate>
      <div class="qb-content-card w-full h-full">
        <div class="flex flex-row gap-4 qb-responsive-split">
          <div class="qb-detail-card w-1/2 h-fit">
            <prox-user-frm [proximityUser]="proximityUser!" [genderModel]="accountUser" [genders]="genders"
              [isBeingAdded]="isBeingAdded" [isReadOnly]="isReadOnly()" [canChangeEmail]="canChangeEmail"
              (emailBlur)="onEmailBlur($event)" (firstNameBlur)="onFirstNameBlur($event)">
              <div emailExtra *ngIf="existingUserMatch" class="text-sm mt-1">
                Existing user:
                <a href="javascript:void(0)" (click)="switchToExistingUser()" class="bluelink">
                  {{existingUserMatch.fullName}} ({{existingUserMatch.username}})
                </a>
              </div>
            </prox-user-frm>
          </div>
          <div class="qb-info-cards w-1/4">
            <p-card header="Current Status" class="status-card">
              <h3>{{accountUser?.proximityUser?.activeStatus?.name}}</h3>
              <p-button size="small" (click)="toggleActivate()" label={{statusButtonLabel()}}></p-button>
            </p-card>
            <!-- Add-mode Helpful Hints — mirrors the Program form's panel
                 (program-info.sub.component.html). Personalized via firstNameForHints.
                 Width tracks the surrounding qb-info-cards column so this panel
                 matches the Current Status card above it. -->
            <div *ngIf="helpfulHints.length > 0" class="mt-4 w-full rounded-md px-4 py-3"
              style="background: var(--p-surface-0); border-left: 3px solid var(--p-amber-500); box-shadow: 0 1px 3px rgba(0,0,0,0.08);">
              <div class="flex items-center gap-2 mb-2">
                <i class="fa-duotone fa-lightbulb text-lg" style="color: var(--p-amber-500);"></i>
                <span class="font-semibold text-base">Helpful Hints</span>
              </div>
              <ul class="list-disc pl-5 text-base flex flex-col gap-1">
                <li *ngFor="let hint of helpfulHints">{{ hint }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <p-tabView class="w-full h-full qb-tabview ml-5" [(activeIndex)]="tabIndex">
        <p-tabPanel header="Program User Groups">
          <div class="h-full flex flex-col" [ngClass]="tabGridWidthClass()">
            <!-- The one always-wrong state gets the only alarm on this tab. Membership alone
                 cannot show it: it is a per-Program fact about a pair of groups. -->
            <div *ngIf="blockedProgramCount > 0"
              class="mb-2 flex items-center gap-3 rounded-md border border-red-200 bg-red-50 px-3 py-2">
              <i class="fa-duotone fa-triangle-exclamation text-lg text-red-600"></i>
              <span class="text-sm text-red-700">
                <strong>{{ blockedProgramCount }}</strong>
                {{ blockedProgramCount === 1 ? 'program is' : 'programs are' }} blocked — this user is in more than
                one group on {{ blockedProgramCount === 1 ? 'it' : 'them' }}. Only one group may govern a program.
              </span>
              <button pButton (click)="goToProgramAccess()" label="Resolve" icon="pi pi-arrow-right"
                class="p-button-sm ml-auto"></button>
            </div>
            <div class="qb-child-actions gap-3">
              <p-button (click)="onPugmAttach()" label="Attach Program User Group" icon="pi pi-plus" size="small"
                [disabled]="isReadOnly()"></p-button>
              <p-button (click)="onViewPrograms()" label="View Programs" icon="pi pi-list" size="small"
                [disabled]="pugms.length === 0"></p-button>
            </div>
            <div class="grow w-full">
              <prox-ag-grid [gridOptions]="pugmGridOptions" [rowData]="pugms"></prox-ag-grid>
            </div>
          </div>
        </p-tabPanel>
        <!-- Program Access: the per-PROGRAM view. Membership is keyed by PUG, but whether the
             user can actually order is keyed by Program, so this is where the invariant is
             stated and where it gets fixed. See Docs/program-user-group-access.md. -->
        <p-tabPanel header="Program Access">
          <div class="h-full flex flex-col">
            <div class="qb-child-actions">
              <span class="text-sm text-gray-600">
                What {{ proximityUser.firstName || 'this user' }} can actually order, and which group each order
                routes through.
              </span>
            </div>
            <div class="grow w-full">
              <prox-ag-grid [gridOptions]="paGridOptions" [rowData]="programAccessRows"></prox-ag-grid>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Shipping User Groups">
          <div class="h-full flex flex-col" [ngClass]="tabGridWidthClass()">
            <div class="qb-child-actions">
              <p-button (click)="onSugmAttach()" label="Attach Shipping User Groups" icon="pi pi-plus" size="small"
                [disabled]="isReadOnly()"></p-button>
            </div>
            <div class="grow w-full">
              <prox-ag-grid [gridOptions]="sugmGridOptions" [rowData]="sugms"></prox-ag-grid>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Personal Shipping Address">
          <div class="qb-child-actions" *ngIf="!accountUser.shippingAccountAddressId">
            <p-button (click)="onAddAddress('S')" label="Add Shipping Address" icon="pi pi-plus" size="small"
              [disabled]="isReadOnly()"></p-button>
          </div>
          <div class="w-1/2" *ngIf="accountUser.shippingAccountAddressId">
            <prox-address-frm [address]="accountUser!.shippingAccountAddress" [disabled]="isReadOnly()" [compact]="true"
              [showContactEmail]="false"></prox-address-frm>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Personal Billing Address">
          <div class="qb-child-actions" *ngIf="!accountUser.billingAccountAddressId">
            <p-button (click)="onAddAddress('B')" label="Add Billing Address" icon="pi pi-plus" size="small"
              [disabled]="isReadOnly()"></p-button>
          </div>
          <div class="w-1/2" *ngIf="accountUser.billingAccountAddressId">
            <prox-address-frm [address]="accountUser!.billingAccountAddress" [disabled]="isReadOnly()" [compact]="true"
              [showContactEmail]="false"></prox-address-frm>
          </div>
        </p-tabPanel>
      </p-tabView>
    </ng-template>
  </p-splitter>
  </ng-container>
</ng-template>

<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()">
    <p-button (click)="viewNotes()" [disabled]="hasChanges()" label="View Notes"
      icon="fa-duotone fa-solid fa-note"></p-button>
    <p-button (click)="onViewLedgers()" [disabled]="isBeingAdded || hasChanges()" label="Ledgers"
      icon="fa-duotone fa-solid fa-book"></p-button>
    <p-button (click)="onSendInvite()" [disabled]="!canSendInvite()" label="Send Invite"
      icon="fa-duotone fa-solid fa-envelope"></p-button>
  </prox-save-cancel>
</ng-template>